export default function recomendarMembresia(respuestas, membresias) {
  // Convertir membresias a array si es necesario
  const listaMembresias = Array.isArray(membresias)
    ? membresias
    : Object.values(membresias);

  // 1. Determinar el mínimo de rutas necesarias basado en la respuesta
  const rutasNecesarias = determinarMinimoRutas(respuestas.routesPerMonth);

  // Filtrar membresias que cumplan con el mínimo de rutas
  let membresiasFiltradas = listaMembresias.filter(
    (m) => m.routeLimit >= rutasNecesarias
  );

  // Si no hay membresias que cumplan, devolver la con mayor límite de rutas
  if (membresiasFiltradas.length === 0) {
    return listaMembresias.reduce((max, curr) =>
      curr.routeLimit > max.routeLimit ? curr : max
    );
  }

  // 2. Calcular puntaje para cada membresia filtrada
  const membresiasConPuntaje = membresiasFiltradas.map((membresia) => {
    let puntaje = 0;

    // Puntos por tipo de logros
    if (respuestas.achievementType === "competicion") {
      puntaje += membresia.price > 0 ? 3 : 0;
    } else if (respuestas.achievementType === "progreso") {
      puntaje += membresia.price > 0 ? 2 : 1;
    }

    // Puntos por objetivo principal
    if (respuestas.mainGoal === "competir") {
      puntaje += membresia.price > 10 ? 3 : 2;
    } else if (
      respuestas.mainGoal === "salud" ||
      respuestas.mainGoal === "peso"
    ) {
      puntaje += membresia.price < 10 ? 2 : 1;
    }

    // Puntos por días de entrenamiento
    if (respuestas.trainingDays === "5+") {
      puntaje += membresia.price > 0 ? 2 : 0;
    } else if (respuestas.trainingDays === "3-4") {
      puntaje += 1;
    }

    // Puntos por nivel de actividad
    if (
      respuestas.activityLevel === "elite" ||
      respuestas.activityLevel === "avanzado"
    ) {
      puntaje += membresia.price > 0 ? 3 : 0;
    } else if (respuestas.activityLevel === "intermedio") {
      puntaje += 1;
    }

    // Puntos por rutas personalizadas
    const minRutasPersonalizadas = determinarMinimoRutas(
      respuestas.customRoutes
    );
    if (minRutasPersonalizadas > 5 && membresia.routeLimit >= 10) {
      puntaje += 3;
    } else if (minRutasPersonalizadas > 2 && membresia.routeLimit >= 5) {
      puntaje += 2;
    }

    return { ...membresia, puntaje };
  });

  // Ordenar por puntaje (mayor primero) y luego por precio (menor primero)
  membresiasConPuntaje.sort((a, b) => {
    if (b.puntaje !== a.puntaje) return b.puntaje - a.puntaje;
    return a.price - b.price;
  });

  return membresiasConPuntaje[0];
}

// Función auxiliar para convertir rangos a números
function determinarMinimoRutas(rango) {
  if (!rango) return 0;

  if (rango === "1-3") return 3;
  if (rango === "4-7") return 7;
  if (rango === "8-12") return 12;
  if (rango === "13+") return 13;
  if (rango === "0-2") return 2;
  if (rango === "3-5") return 5;
  if (rango === "6-10") return 10;
  if (rango === "10+") return 11;

  // Para trainingDays
  if (rango === "1-2") return 2;
  if (rango === "3-4") return 4;
  if (rango === "5+") return 5;

  return 0;
}
